import { render, staticRenderFns } from "./Excluir.vue?vue&type=template&id=71e9ba9d&"
import script from "./Excluir.vue?vue&type=script&lang=js&"
export * from "./Excluir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports